<template>
    <div>JobSeekers</div>
</template>

<script>
export default {
    name: "JobSeekers",
};
</script>

<style scoped></style>
